<div [ngClass]="{'amway-min-content-area':loading}">
  <!-- content area -->
  <router-outlet></router-outlet>
  <!-- end content area -->
  <app-loader [visible]="loading"
    [cover]="true"></app-loader>
  <ng-template #dynamicTokenExpiry></ng-template>
  <ng-template #dynamicNotification></ng-template>
</div>

<!-- captcha -->
<div class="action amway-theme recaptcha-section">
  <div id="r-captcha"
    class="g-recaptcha hide-captcha"
    data-size="invisible"
    data-badge="bottomright"></div>
</div>
